import Icon from 'components/darwin-ui/Icon';
import { useTranslation } from 'react-i18next';
import styles from './index.module.css';
import type { ReactNode } from 'react';

const BASE = 'process-flow.data-capture.flat-file.recommendations';

const TOP_KEYS = [
  'file-format',
  'column-order',
  'download-template',
  'product',
  'quantity',
] as const;

const BOTTOM_KEYS = [
  'locations',
  'unit-of-measure',
  'reference-document-number',
  'reference-document-type',
  'external-code',
] as const;

const DATE_FORMAT_KEYS = [
  'format1',
  'format2',
  'format3',
  'format4',
  'format5',
  'format6',
  'format7',
  'format8',
] as const;

const Item = ({ children }: { children: ReactNode }) => (
  <li className={styles.listItem}>
    <span className={styles.iconCell}>
      <Icon name="list-check" color="white" size="xs" />
    </span>
    <span className={styles.text}>{children}</span>
  </li>
);

const DatesItem = () => {
  const { t } = useTranslation();
  return (
    <Item>
      {t(`${BASE}.dates.intro`)}
      <div className={styles.indented}>
        {DATE_FORMAT_KEYS.map(k => (
          <div key={k}>{t(`${BASE}.dates.${k}`)}</div>
        ))}
      </div>
      {t(`${BASE}.dates.future-note`)}
    </Item>
  );
};

export const RequirementsCard = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>{t(`${BASE}.title`)}</h3>
      <ul className={styles.list}>
        {TOP_KEYS.map(k => (
          <Item key={k}>{t(`${BASE}.${k}`)}</Item>
        ))}
        <DatesItem />
        {BOTTOM_KEYS.map(k => (
          <Item key={k}>{t(`${BASE}.${k}`)}</Item>
        ))}
      </ul>
    </div>
  );
};
